import React from 'react';
import styled from 'styled-components';
import {
  Container as LoaderContainer,
  Bars as LoaderBars,
  Bar as LoaderBar,
  Text as LoaderText,
} from '@rsos/components/capstone/Loader/Loader';
import { Box, Absolute } from '@rsos/components/capstone/base';

export const TableWrapper = styled(Box)`
  position: relative;
`;
export const IntegrationTable = styled.div`
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  min-height: 362px;
  padding: 21px 24px;
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  grid-template-columns: 1.53fr 1.67fr 1.67fr 0.7fr;
  grid-column-gap: 16px;
  grid-row-gap: 10px;
  grid-auto-rows: min-content;
  border-radius: 5px;
`;

export const IntegrationTableHead = styled.div`
  display: contents;
`;
export const IntegrationTableBody = styled.div`
  display: contents;
`;
export const IntegrationTableTR = styled.div`
  display: contents;
`;
export const IntegrationTableTD = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primaryText};
`;
export const IntegrationTableTH = styled.div`
  padding: 15px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: sticky;
  top: 0;
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const CustomErrorWrapper = styled(Box).attrs({
  horizontal: true,
  flow: 5,
  color: 'lightDanger',
  align: 'center',
})`
  grid-column: 1 / -1;
  max-width: 510px;
`;
export const LoaderWrapper = styled(Box).attrs({
  bg: '#00000080',
  height: '100%',
  justify: 'center',
  align: 'center',
})``;

const IntegrationTestsLoaderBar = styled(LoaderBar)`
  background-color: #fff;
`;
const IntegrationtestsLoaderText = styled(LoaderText)`
  color: #fff;
`;
export const IntegrationTestsLoader = () => (
  <LoaderContainer>
    <LoaderBars>
      <IntegrationTestsLoaderBar />
      <IntegrationTestsLoaderBar />
      <IntegrationTestsLoaderBar />
      <IntegrationTestsLoaderBar />
      <IntegrationTestsLoaderBar />
    </LoaderBars>
    <IntegrationtestsLoaderText>Testing...</IntegrationtestsLoaderText>
  </LoaderContainer>
);
export const LoaderOverlay = () => {
  return (
    <Absolute bottom={0} top={0} left={0} right={0}>
      <LoaderWrapper>
        <IntegrationTestsLoader />
      </LoaderWrapper>
    </Absolute>
  );
};
